/* eslint guard-for-in:0 */
/* global PortalL10n */

/**
 * PortalCommon
 */

const { log, error } = require("./PortalLogging");
const PortalApi = require("./PortalApi");
const PortalElementSimpleSearch = require("./PortalElementSimpleSearch");
const PortalElementFieldSearch = require("./PortalElementFieldSearch");
const PortalElementCarousel = require("./PortalElementCarousel");

const props = ["api", "elements", "display"];

module.exports = class PortalCommon {

  constructor(opts = {}) {
    props.forEach((prop) => {
      if (opts[prop] === undefined)
        throw new Error(`Missing required prop "${prop}" for PortalCommon`);
    });

    log("new PortalCommon", opts);

    Object.assign(this, opts);
    this.api = new PortalApi(opts.api);
    this.elements = [];
    this.opts = opts;
    this.easydb_groups = [];

    this.setPortalLang(opts.language, "de-DE");
    
    let token = PortalStorage.getTokenFromCookies();
    if (token) {
        this.api.retrieveCurrentSession(token)
        .then((data) =>  {
          if (data && data.token && data.user && data.user.user) {
            this.setCookiesAndInitiateSearch(data, opts);
          } else {
            window.alert("Session has been expired. You will be logged out.");
            PortalStorage.clearOutCookie();
            this.initiateNewSession(this.lang, opts, this.api.apiuser, this.api.apipass);
          }
        });
    } else {
        this.opts.shouldShowLoginPopupByDefault = true;
        this.initiateNewSession(this.lang, opts, this.api.apiuser, this.api.apipass);
    }

  }

  initiateNewSession(lang, opts, username, password) {
    this.startSession(lang, username, password).then((ret) => {
      if (ret && ret.token && ret.user && ret.user.user) {
        this.setCookiesAndInitiateSearch(ret, opts);
      }
    });
  }

  setCookiesAndInitiateSearch(data, opts) {
    this.setCookies(data);
    this.initiateSearchAfterAuthentication(opts);
  }

  setCookies(data) {
    let schaufensterdisplayName = this.getSchaufensterDisplayName(data.user.user);
    PortalStorage.setUserCredentials(data.token, schaufensterdisplayName);
  }

  getSchaufensterDisplayName(user) {
    if (user._generated_displayname) {
      return user._generated_displayname;
    } else if (user.displayname) {
      return user.displayname;
    } else if (user.login) {
      return user.login;
    } else {
      return "null";
    }
  }

  get lang() {
    return PortalL10n.lang;
  }

  // Set language for the Portal
  setPortalLang(newLanguage, defaultLanguage) { 
    PortalL10n.lang = typeof newLanguage != "undefined" && newLanguage ? newLanguage : defaultLanguage;
  }


  initiateSearchAfterAuthentication(opts) {
    this.setDisplayMessages();
    this.setUpElements(opts);
    this.initElements();
  }


  handleSuccessfulAuthentication(ret) {
    if (typeof ret.groups != "undefined") {
      ret.groups.forEach((g) => {
        this.easydb_groups.push(g.group._id);
      });
    }
  }

  handleSuccessfulSessionSetUp(data, inputUsername, inputPassword) {
    if (data.token) {
      // Validate & Authenticate Session token associating with input username & pass;
      return this.api.authenticate(data.token, inputUsername, inputPassword);
    }
  }

  // Starts and Sets up Session 
  startSession(language, inputUsername, inputPassword) {

    return new Promise((resolve, reject) => {
      
        // TODO Raghav: Handle Fall Back Case of Expired Token in Cookie
        // TODO Raghav: If Search API Hits and Session is expired then deauthenticate token session and log out user, request user to login again
        // TODO Raghav: Handle Session API Failure and token missing
        // TODO Raghav: Logout clear out token, username from cookie and (deauthenticate token)?
        this.api.startSession(language)
        .then((data) => {
          return this.handleSuccessfulSessionSetUp(data, inputUsername, inputPassword);
        })
        .then((ret) => {
          if (ret.token) {
            this.handleSuccessfulAuthentication(ret);
            resolve(ret);
          } else {
            reject(ret);
          }
        })
        .catch((error) => {
          console.log(error); 
          reject();
        });

    });

  }

  // Sets Display Messages
  setDisplayMessages() {
    if ( typeof this.display.message_target != "undefined" && this.display.message_target) {
      this.api.getMessages(this.easydb_groups).then((ret) => {
        let show_message = false;
        ret.objects.forEach((o) => {
          $(this.display.message_target).append(
            "<h2>" +
              o.message.title[this.lang] +
              "</h2>" +
              o.message.message[this.lang]
          );
          show_message = true;
        });
        if (show_message) {
          $(this.display.message_target).show();
        }
      }).catch((result) => {
        window.alert("Session has expired. You have been logged out. Please login again.");
        location.reload();
    });
    }
  }

  // Sets up Elements and initiate each element
  setUpElements(opts) {
    if (typeof opts.elements != "undefined") {
      opts.elements.forEach((el) => {
        if (el.type == "search")
          this.elements.push(
            new PortalElementSimpleSearch({ el: el, parent: this })
          );
        if (el.type == "fieldsearch")
          this.elements.push(
            new PortalElementFieldSearch({ el: el, parent: this, shouldShowLoginPopupByDefault: opts.shouldShowLoginPopupByDefault })
          );
        if (el.type == "carousel")
          this.elements.push(
            new PortalElementCarousel({ el: el, parent: this })
          );
      });
    }
  }

  initElements() {
    this.elements.forEach((el) => {
      el.init();
    });
  }

  init() {}
  
};



//////////////////
// WEBPACK FOOTER
// ./js/PortalCommon.js
// module id = 10
// module chunks = 0